import React from 'react';
import { useBusinessRules } from '@common/components/Business/rules';
import { BusinessAddress as InnerField } from '@common/components/BusinessForm/components/BusinessAddress/BusinessAddress';
import { FieldWrapper } from '../FieldWrapper';

export default function BusinessAddress({ initialValue, countryCode }) {
  const { businessAddressRules } = useBusinessRules();

  return (
    <FieldWrapper<any>
      name="businessAddress"
      rules={businessAddressRules}
      render={(props: any) => {
        return (
          <InnerField
            {...props}
            initialValue={initialValue}
            country={countryCode}
          />
        );
      }}
    />
  );
}
